module.exports = __webpack_public_path__ + "static/mask-1-f110ec8bfccdc95e0fca0be0903fbd60.png";